import React, { FC, useCallback } from 'react';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MdArrowForward as ArrowIcon } from '@react-icons/all-files/md/MdArrowForward';
import { MdClear as ClearIcon } from '@react-icons/all-files/md/MdClear';
import { Box, IconButton, InputAdornment } from '@material-ui/core';
import moment, { Moment } from 'moment';
import MomentUtils from '@date-io/moment';

interface Props {
  startDate?: string;
  endDate?: string;
  onChange: (startDate?: string, endDate?: string) => void;
}

const DateRangeInput: FC<Props> = ({ startDate, endDate, onChange }) => {
  const formatDate = (date?: Moment | null) => (date ? date.format('YYYY-MM-DD') : undefined);
  const momentDate = (date?: string) => (date ? moment(date, 'YYYY-MM-DD') : null);

  const handleClearStartDate = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onChange(undefined, endDate);
    },
    [onChange, endDate]
  );
  const handleClearEndDate = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onChange(startDate, undefined);
    },
    [onChange, startDate]
  );

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Box display='flex' alignItems='center'>
        <Box maxWidth='180px' clone>
          <DatePicker
            label='Date de début'
            format='DD/MM/YYYY'
            inputVariant='outlined'
            size='small'
            value={momentDate(startDate)}
            onChange={useCallback((date) => onChange(formatDate(date), endDate), [onChange, endDate])}
            InputProps={{
              endAdornment: startDate && (
                <InputAdornment position='end'>
                  <IconButton onClick={handleClearStartDate}>
                    <ClearIcon color='disabled' fontSize='small' />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box mx='5px' clone>
          <ArrowIcon size={14} />
        </Box>

        <Box maxWidth='180px' clone>
          <DatePicker
            label='Date de fin'
            format='DD/MM/YYYY'
            inputVariant='outlined'
            size='small'
            value={momentDate(endDate)}
            onChange={useCallback((date) => onChange(startDate, formatDate(date)), [onChange, startDate])}
            InputProps={{
              endAdornment: endDate && (
                <InputAdornment position='end'>
                  <IconButton onClick={handleClearEndDate}>
                    <ClearIcon color='disabled' fontSize='small' />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
    </MuiPickersUtilsProvider>
  );
};

export default DateRangeInput;
